import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: "https://lws-server.herokuapp.com",
    }),
    tagTypes: ["Todos"],
    endpoints: (builder) => ({
        getTodos: builder.query({
            query: () => "/todos",
            providesTags: ["Todos"],
        }),
        addTodo: builder.mutation({
            query: (data) => ({
                url: "/todos",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Todos"],
        }),
        updateTodo: builder.mutation({
            query: ({id, todoText}) => ({
                url: `/todos/${id}`,
                method: "PATCH",
                body: {
                    text: todoText
                },
            }),
            invalidatesTags: (result, error, arg) => [
                "Todos",
            ],
        }),
        updateStatus: builder.mutation({
            query: ({id, currentStatus}) => ({
                url: `/todos/${id}`,
                method: "PATCH",
                body: {
                    completed: !currentStatus
                },
            }),
            invalidatesTags: (result, error, arg) => [
                "Todos",
            ],
        }),
        updateColor: builder.mutation({
            query: ({id, color}) => ({
                url: `/todos/${id}`,
                method: "PATCH",
                body: {
                    color: color
                },
            }),
            invalidatesTags: (result, error, arg) => [
                "Todos",
            ],
        }),
        deleteTodo: builder.mutation({
            query: (id) => ({
                url: `/todos/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Todos"],
        }),
        allCompleted: builder.mutation({
            query: (todo) => ({
                url: `/todos/${todo.id}`,
                method: "PATCH",
                body: {
                    completed: true
                }
            }),
            invalidatesTags: ["Todos"],
        }),
        clearCompleted: builder.mutation({
            query: (todo) => ({
                url: `/todos/${todo.id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Todos"],
        }),
    }),
});

export const {
    useGetTodosQuery,
    useUpdateStatusMutation,
    useUpdateColorMutation,
    useDeleteTodoMutation,
    useUpdateTodoMutation,
    useAddTodoMutation,
    useAllCompletedMutation,
    useClearCompletedMutation
} = apiSlice;
